const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_AutomationList":
      return { ...state, List: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
